import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Switch,
  TextField,
  Typography,
  Autocomplete,
  CircularProgress,
  createFilterOptions,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear, FileUploadOutlined } from "@mui/icons-material";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";

import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import { DesktopDatePicker } from "@mui/lab";
import { DateTimePicker } from "@mui/x-date-pickers";

import { json, Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ArrowBack } from "@mui/icons-material";
import ErrorProps from "../../../Component/Errorprops";
import { fromUTC, toUTC, getDateWithOutUTC } from "../../../utils/dateUtil";
import { isSystemAccess } from "../../../ConfigInfo/Info";

const AssetModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();

  const mode = useSelector((state) => state.editData.assetEditData.edit);
  const editData = useSelector((state) => state.editData.assetEditData.data);
  const isSystem = useSelector((state) => isSystemAccess(state.auth.loginInfo));
  console.log(editData);

  const [assetCategory, setAssetCategory] = useState([]);
  const [assetType, setAssetType] = useState([]);
  //const [uom, setUom] = useState([]);
  const [location, setLocation] = useState([]);
  const [system, setSystem] = useState([]);

  const [failureClasses, setFailureClasses] = useState([]);
  const [assetPriority, setAssetPriority] = useState([]);
  const [assetCriticality, setAssetCriticality] = useState([]);
  const [assetStatus, setAssetStatus] = useState([]);
  const [parentAsset, setParentAsset] = useState([]);
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [suppiler, setSuppiler] = useState([]);
  const [manufacturer, setManufacturer] = useState([]);
  const [activeStatusId, setActiveStatusId] = useState("");
  const [model, setModel] = useState([]);
  const [loading, setLoading] = useState(false);

  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    //////Criticality///////
    const link = masterAPI["selectList"].criticalitybyType;
    await axiosPrivate
      .get(`${link}/Asset`)
      .then((res) => {
        setAssetCriticality(res.data);
      })
      .catch((e) => {
        setAssetCriticality([]);
        console.log(e, "createAcritigetAll");
      });
    /////////Category//////
    const assetCat = masterAPI["assetCategory"].link;
    await axiosPrivate
      .get(`${assetCat}`)
      .then((res) => {
        console.log(res);
        setAssetCategory(res.data.result);
      })
      .catch((e) => {
        setAssetCategory([]);
        console.log(e, "createACgetAll");
      });
    //////Asset Type/////
    const assetTyp = masterAPI["assetType"].link;
    await axiosPrivate
      .get(`${assetTyp}`)
      .then((res) => {
        setAssetType(res.data.result);
      })
      .catch((e) => {
        setAssetType([]);
        console.log(e, "createAssetTypegetAll");
      });

    ////////failure Classes/////
    const failClass = masterAPI["failureClass"].link;
    await axiosPrivate
      .get(`${failClass}`)
      .then((res) => {
        setFailureClasses(res.data.result);
      })
      .catch((e) => {
        setFailureClasses([]);
        console.log(e, "createfailureClassgetAll");
      });
    /////////asset Priority//////////
    const assetPri = masterAPI["priority"].link;
    await axiosPrivate
      .get(`${assetPri}`)
      .then((res) => {
        setAssetPriority(res.data.result);
      })
      .catch((e) => {
        setAssetPriority([]);
        console.log(e, "createAssetPrigetAll");
      });
    //////assetStatus///////
    const assetSta = masterAPI["assetStatus"].link;
    await axiosPrivate
      .get(assetSta)
      .then((res) => {
        console.log(res.data.result, "statusall");

        // Safely access the array
        const list = res.data?.result ?? [];

        // Find "ACTIVE" or "Active" (case-insensitive)
        const activeItem = list.find(
          (item) => item.statusName?.toLowerCase() === "active",
        );

        if (activeItem) {
          setActiveStatusId(activeItem.id);
          console.log("Active Status ID:", activeItem.id);
        } else {
          console.warn("No ACTIVE status found");
        }

        setAssetStatus(list);
      })
      .catch((e) => {
        setAssetStatus([]);
        console.error("createStatusgetAll:", e);
      });
    ///////////parent Asset///////
    const assets = masterAPI["assets"].link;
    await axiosPrivate
      .get(`${assets}`)
      .then((res) => {
        setParentAsset(res.data.result);
      })
      .catch((e) => {
        setParentAsset([]);
        console.log(e, "createParentAssetgetAll");
      });
    /////////Location//////
    const locationLink = masterAPI["location"].link;
    await axiosPrivate
      .get(`${locationLink}`)
      .then((res) => {
        setLocation(res.data.result.filter((fil) => fil.isActive));
      })
      .catch((e) => {
        setLocation([]);
        console.log(e, "createLocationgetAll");
      });
    /////////System//////
    if (isSystem) {
      const systemLink = masterAPI["system"].link;
      await axiosPrivate
        .get(`${systemLink}`)
        .then((res) => {
          setSystem(res.data.result.filter((fil) => fil.isActive));
        })
        .catch((e) => {
          setSystem([]);
          console.log(e, "createSystemgetAll");
        });
    }
    const typeLink = masterAPI["selectList"].businessByType;

    await axiosPrivate
      .get(`${typeLink}?businessType=Supplier`)
      .then((res) => {
        console.log(res);
        setSuppiler(res.data);
      })
      .catch((e) => {
        setSuppiler([]);
        console.log(e, "error");
      });

    await axiosPrivate
      .get(`${typeLink}?businessType=Manufacturer`)
      .then((res) => {
        setManufacturer(res.data);
      })
      .catch((e) => {
        setManufacturer([]);
        console.log(e, "error");
      });

    if (mode && editData.assetType !== null) {
      handleModelWithAssetType(editData.assetTypeId);
    }
  };

  const handleModelWithAssetType = (assetTypeId) => {
    const getModelbyassetTypeIdLink =
      masterAPI["master_model"].getModelbyAssetType;
    axiosPrivate
      .get(`${getModelbyassetTypeIdLink}/${assetTypeId}`)
      .then((res) => {
        setModel(res.data.result);
      })
      .catch((e) => {
        setModel([]);
        console.log(e, "error");
      });
  };

  const initialValue = {
    assetName: mode ? editData.assetName : "",
    code: mode ? editData.code : "",
    serialNumber: mode ? editData.serialNumber : "",
    model: mode ? editData.model : "",
    purchasePrice: mode ? editData.purchasePrice : 0,
    warrantyName: mode ? editData.warrantyName : "",
    warrantyType: mode
      ? editData.warrantyType === "Basic"
        ? false
        : true
      : false,
    installationDate: mode
      ? editData.installationDate
        ? fromUTC(editData.installationDate).tzString
        : null
      : null,
    startDate: mode
      ? editData.startDate
        ? fromUTC(editData.startDate).tzString
        : null
      : null,
    expirationDate: mode
      ? editData.expirationDate
        ? fromUTC(editData.expirationDate).tzString
        : null
      : null,
    threshHoldCalendar: mode ? editData.threshHoldCalendar : null,
    modelId: mode ? editData.modelId : null,
    startingUsage: mode ? editData.startingUsage : "",
    expirationUsage: mode ? editData.expirationUsage : "",
    assetTypeId: mode ? editData.assetTypeId : null,
    locationId: mode ? editData.locationId : null,
    systemId: mode ? editData.systemId : null,
    uomId: mode ? editData.uomId : null,
    partId: mode ? editData.partId : null,
    stockRoomId: mode ? editData.stockRoomId : null,
    assetCategoryId: mode ? editData.assetCategoryId : null,
    failureClassesId: mode ? editData.failureClassesId : null,
    priorityId: mode ? editData.priorityId : null,
    criticalityId: mode ? editData.criticalityId : null,
    assetStatusId: mode ? editData.assetStatusId : null,
    parentAssetId: mode ? editData.parentAssetId : null,
    // assetStatusId:mode  ? editData.parentAssetId :null,
    comments: mode ? editData.comments : "",
    notes: mode ? editData.notes : "",
    // techSpecId: mode === "Edit" ? editData.techSpecId : "",
    qrCodeData: mode ? editData.qrCodeData : "",
    assetImage: mode ? editData.assetImage.split(".com")[1] : "",
    imageData: "",
    supplierId: mode ? editData.supplierId : null,
    manufacturerId: mode ? editData.manufacturerId : null,
  };

  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true);
    const createLink = masterAPI["assets"].create;
    const updateLink = masterAPI["assets"].update;

    // Convert date fields to UTC
    const convertedValues = {
      ...value,
      installationDate: value.installationDate
        ? toUTC(value.installationDate).utcISOString
        : value.installationDate,
      startDate: value.startDate
        ? toUTC(value.startDate).utcISOString
        : value.startDate,
      expirationDate: value.expirationDate
        ? toUTC(value.expirationDate).utcISOString
        : value.expirationDate,
    };

    if (!mode) {
      const postData = {
        ...convertedValues,
        ["warrantyType"]: value.warrantyType ? "Extended" : "Basic",
        ["assetStatusId"]: activeStatusId,
      };
      console.log(postData);
      await axiosPrivate
        .post(`${createLink}`, postData)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          // handleCloseClick();
          navigate("/asset/assets");
        })
        .catch((e) => {
          setLoading(false);
          toast.error(e.response.data.failureMessage);
          console.log(e, "createAssets");
        });
    } else {
      const updateAC = {
        id: editData.id,

        ...convertedValues,
        ["warrantyType"]: value.warrantyType ? "Extended" : "Basic",
      };

      console.log(updateAC);
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          // handleCloseClick();
          // localStorage.setItem('editData',"")
          dispatch({
            type: "assetEditData",
            payload: { edit: false, data: {} },
          });
          navigate("/asset/assets");
        })
        .catch((e) => {
          setLoading(false);
          toast.error(e.response.data.failureMessage);
          console.log(e, "updateAssets");
        });
    }
  };

  const handleCancel = () => {
    // handleCloseClick();
    navigate("/asset/assets");
  };
  const validationSchema = Yup.object().shape({
    code: Yup.string().required("Code is required"),
    assetName: Yup.string().required("Asset Name is required"),
    locationId: Yup.string().required("This field is required"),
    // locationId: Yup.string().when("parentAssetId", {
    //   is: (val) => val === null,
    //   then: (schema) => schema.required("Loction is required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    //  parentAssetId: Yup.string().when("locationId", {
    //   is: (val) => val === null,
    //   then: (schema) => schema.required("Parent Asset is required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
  });
  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: "1.3rem",
            fontWeight: 500,
            mb: "0.5rem",
          }}
        >
          <Link to="/asset/assets">
            <IconButton>
              <ArrowBack />
            </IconButton>
          </Link>
          {mode ? `${editData.code + "_" + editData.assetName}` : "New Assets"}
        </Typography>
        {/* <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton> */}
      </Box>
      {/* <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} /> */}
      {/* <Paper sx={{p:2}}> */}
      <Formik
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Box
              sx={{
                display: "flex",
                gap: "1rem",
                flexWrap: "noWrap",
                width: "100%",
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Paper
                sx={{
                  width: { xs: "100%", sm: "49%" },
                  flex: "0 0 49%",
                  p: 1.5,
                }}
              >
                <Grid container spacing={"0.5rem"}>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Asset Code
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="text"
                      value={values.code}
                      name="code"
                      placeholder="Enter Asset Code"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                    <ErrorMessage name="code">
                      {(error) => <ErrorProps>{error}</ErrorProps>}
                    </ErrorMessage>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Asset Name
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="text"
                      name="assetName"
                      placeholder="Enter Asset  Name"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                    <ErrorMessage name="assetName">
                      {(error) => <ErrorProps>{error}</ErrorProps>}
                    </ErrorMessage>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Location
                    </Typography>
                    <Field
                      name="locationId"
                      value={
                        location.find((loc) => loc.id === values.locationId) ||
                        null
                      }
                      component={Autocomplete}
                      disabled={mode}
                      filterOptions={filterOptions}
                      loading={location.length === 0}
                      options={location}
                      PaperComponent={CustomPaper}
                      getOptionLabel={(option) =>
                        option ? option.code + " - " + option.locationName : ""
                      }
                      onChange={(event, value) => {
                        if (value) {
                          setFieldValue("locationId", value.id);
                        } else {
                          setFieldValue("locationId", null);
                          setFieldValue("parentAssetId", null);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="locationId"
                          placeholder="Search Location"
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {location.length === 0 ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                    <ErrorMessage name="locationId">
                      {(error) => <ErrorProps>{error}</ErrorProps>}
                    </ErrorMessage>
                  </Grid>
                  {isSystem && (
                    <Grid item xs={12} md={6}>
                      <Typography
                        sx={{
                          fontWeight: color.labelFontWeight,
                          mb: color.labelmb,
                          fontSize: color.labelFont,
                          color: color.labelColor,
                        }}
                      >
                        System
                      </Typography>
                      <Field
                        name="systemId"
                        value={
                          system.find((sys) => sys.id === values.systemId) ||
                          null
                        }
                        disabled={mode  }
                        component={Autocomplete}
                        filterOptions={filterOptions}
                        loading={system.length === 0}
                        options={system}
                        PaperComponent={CustomPaper}
                        getOptionLabel={(option) =>
                          option ? option.systemCode + " - " + option.systemName : ""
                        }
                        freeSolo
                        onChange={(event, value) => {
                          if (value) {
                            setFieldValue("systemId", value.id);
                          } else {
                            setFieldValue("systemId", null);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="systemId"
                            placeholder="Search System"
                            onChange={handleChange}
                            size="small"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {system.length === 0 ? (
                                    <CircularProgress color="inherit" size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Parent Asset
                    </Typography>
                    {/* <Field
                  as={Select}
                  // label={"Select"}
                  size={"small"}
                  type="text"
                  name="parentAssetId"
                  fullWidth
                  displayEmpty
                  MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                
                  renderValue={
                    values.parentAssetId !== null
                      ? undefined
                      : () => (
                          <Typography
                            sx={{
                              color: color.placeholderColor,
                              fontSize: "13px",
                            }}
                          >
                            Select
                          </Typography>
                        )
                  }
                >
                  {parentAsset.map((id, i) => (
                    <MenuItem key={i} value={id.id} 
                    onClick={()=>{
                    
                      setFieldValue("locationId",id.locationId)
                      setLocation(id.locationName)
                    }} 
                    >{id.code+" - "+id.assetName}</MenuItem>
                  ))}
                </Field> */}
                    <Field
                      name="parentAssetId"
                      value={
                        parentAsset.find(
                          (a) => a.id === values.parentAssetId,
                        ) || null
                      }
                      disabled={mode}
                      component={Autocomplete}
                      filterOptions={filterOptions}
                      loading={parentAsset.length === 0}
                      options={parentAsset}
                      PaperComponent={CustomPaper}
                      getOptionLabel={(option) =>
                        option ? option.code + " - " + option.assetName : ""
                      }
                      getOptionDisabled={(option) =>
                        editData.id === option.id && mode
                      }
                      onChange={(event, value) => {
                        if (value) {
                          console.log(value);
                          setFieldValue("locationId", value.locationId);
                          setFieldValue("parentAssetId", value.id);
                        } else {
                          setFieldValue("locationId", null);
                          setFieldValue("parentAssetId", null);
                          // setFieldValue("failureClassId",null)
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="parentAsset"
                          placeholder="Search Parent Asset"
                          onChange={handleChange}
                          size="small"
                          // variant="standard"

                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                {parentAsset.length === 0 ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    >
                      {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                    </Field>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Asset Type
                    </Typography>
                    <Field
                      name="assetTypeId"
                      value={
                        assetType.find(
                          (at) => at.id === values.assetTypeId,
                        ) || null
                      }
                      component={Autocomplete}
                      filterOptions={filterOptions}
                      loading={assetType.length === 0}
                      options={assetType}
                      PaperComponent={CustomPaper}
                      getOptionLabel={(option) =>
                        option ? option.code + " - " + option.assetTypeName : ""
                      }
                   
                      onChange={(event, value) => {
                        if (value) {
                          console.log(value);
                          setFieldValue("assetTypeId", value.id);
                          setFieldValue("modelId", null);
                          handleModelWithAssetType(value.id);
                        } else {
                          setFieldValue("assetTypeId", null);
                          setFieldValue("modelId", null);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="assetTypeId"
                          placeholder="Search Asset Type"
                          onChange={handleChange}
                          size="small"
                          // variant="standard"

                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                {assetType.length === 0 ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    ></Field>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Asset Category
                    </Typography>
                    <Field
                      as={Select}
                      // label={"Select"}
                      size={"small"}
                      type="text"
                      name="assetCategoryId"
                      fullWidth
                      displayEmpty
                      MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                      renderValue={
                        values.assetCategoryId !== null
                          ? undefined
                          : () => (
                              <Typography
                                sx={{
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                }}
                              >
                                Select
                              </Typography>
                            )
                      }
                    >
                      {assetCategory.map((id, i) => (
                        <MenuItem value={id.id}>
                          {id.code + " - " + id.assetCategoryName}
                        </MenuItem>
                      ))}
                    </Field>
                  </Grid>

                  {/* <Grid item xs={12} md={6}>
              
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                 Parts
                </Typography>
                
                 <Field
                       name="partId"
                           inputValue={auto.part}
                           component={Autocomplete}
                           filterOptions={filterOptions}
                           loading={partData.length === 0}
                           options={partData} 
                           PaperComponent={CustomPaper}
                          
                           getOptionLabel={(option) => option.code+" - "+option.partName || option}
                           freeSolo
                         onChange={(event,value) => {
                          
                       if(value){
                       
                        setFieldValue("partId",value.id)
                        setAuto({...auto,part:value.code+ " - "+value.partName})
                      
                    
                       }else{
                        setFieldValue("partId",null)
                        setAuto({...auto,part:""})
                        // getData()
                        // setFieldValue("failureClassId",null)
                       }
                        
                        }}
                        onInputChange={(e,v)=>{
                          setAuto({...auto,part:v})
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="partId"
                           placeholder="Search Part"
                            onChange={handleChange}
                            size="small"
                            // variant="standard"
                           
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                  {/* {partData.length === 0 ? <CircularProgress color="inherit" size={20} /> : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>),
                            }}
                           />
                           )}
                      >  */}

                  {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                  {/* </Field>
              </Grid> */}
                  {/* <Grid item xs={12} md={6}>
              
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                 Stock Room
                </Typography>
                
                 <Field
                       name="stockRoomId"
                           inputValue={auto.stockroom}
                           component={Autocomplete}
                           filterOptions={filterOptions}
                           loading={stockRoomData.length === 0}
                           options={stockRoomData} 
                           PaperComponent={CustomPaper}
                          
                           getOptionLabel={(option) => option.code+" - "+option.stockRoomName || option}
                           freeSolo
                         onChange={(event,value) => {
                          
                       if(value){
                       
                        setFieldValue("stockRoomId",value.id)
                        setAuto({...auto,stockroom:value.code+ " - "+value.stockRoomName})
                      
                    
                       }else{
                        setFieldValue("stockRoomId",null)
                        setAuto({...auto,stockroom:""})
                        // getData()
                        // setFieldValue("failureClassId",null)
                       }
                        
                        }}
                        onInputChange={(e,v)=>{
                          setAuto({...auto,stockroom:v})
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="stockRoomId"
                           placeholder="Search Stock Room"
                            onChange={handleChange}
                            size="small"
                            // variant="standard"
                           
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment> */}
                  {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                  {/* {partData.length === 0 ? <CircularProgress color="inherit" size={20} /> : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>),
                            }}
                           />
                           )}
                      > */}

                  {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                  {/* </Field>
              </Grid> */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Asset Priority
                    </Typography>
                    <Field
                      as={Select}
                      // label={"Select"}
                      size={"small"}
                      type="text"
                      name="priorityId"
                      fullWidth
                      displayEmpty
                      MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                      renderValue={
                        values.priorityId !== null
                          ? undefined
                          : () => (
                              <Typography
                                sx={{
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                }}
                              >
                                Select
                              </Typography>
                            )
                      }
                    >
                      {assetPriority.map((id, i) => (
                        <MenuItem value={id.id}>
                          {id.code + " - " + id.priorityName}
                        </MenuItem>
                      ))}
                    </Field>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Criticality
                    </Typography>
                    <Field
                      as={Select}
                      // label={"Select"}
                      size={"small"}
                      type="text"
                      name="criticalityId"
                      fullWidth
                      displayEmpty
                      MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                      renderValue={
                        values.criticalityId !== null
                          ? undefined
                          : () => (
                              <Typography
                                sx={{
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                }}
                              >
                                Select
                              </Typography>
                            )
                      }
                    >
                      {assetCriticality.map((id, i) => (
                        <MenuItem value={id.value}>{id.text}</MenuItem>
                      ))}
                    </Field>
                  </Grid>

                  {/* <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Asset Status
                </Typography>
                <Field
                  as={Select}
                  // label={"Select"}
                  size={"small"}
                  type="text"
                  name="assetStatusId"
                  fullWidth
                  displayEmpty
                  MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                  renderValue={
                    values.assetStatusId !== null
                      ? undefined
                      : () => (
                          <Typography
                            sx={{
                              color: color.placeholderColor,
                              fontSize: "13px",
                            }}
                          >
                            Select
                          </Typography>
                        )
                  }
                >
                  {assetStatus.map((id, i) => (
                    <MenuItem value={id.id}>{id.statusName}</MenuItem>
                  ))}
                </Field>
              </Grid> */}
                  {/* <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                 QR Code Data
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="qrCodeData"
                  placeholder="Enter Qr Code Data"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid> */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Failure Class
                    </Typography>
                    <Field
                      as={Select}
                      // label={"Select"}
                      size={"small"}
                      type="text"
                      name="failureClassesId"
                      fullWidth
                      displayEmpty
                      MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                      renderValue={
                        values.failureClassesId !== null
                          ? undefined
                          : () => (
                              <Typography
                                sx={{
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                }}
                              >
                                Select
                              </Typography>
                            )
                      }
                    >
                      {failureClasses.map((id, i) => (
                        <MenuItem value={id.id}>
                          {id.code + " - " + id.failureClassName}
                        </MenuItem>
                      ))}
                    </Field>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Document File
                    </Typography>
                    <Button component="label" variant="contained">
                      <FileUploadOutlined />{" "}
                      <Typography sx={{ fontSize: "0.9rem" }}>
                        Add File
                      </Typography>
                      <input
                        type="file"
                        accept={"image/*"}
                        hidden
                        onChange={(e) => {
                          console.log(e.target.files[0]);
                          if (e.target.files[0] !== undefined) {
                            const file = e.target.files[0];
                            console.log(file.name);
                            const fileType = file.type.split("/")[1];
                            console.log(fileType);
                            // if (!file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/)) {

                            //   toast.error("Invalid format");
                            // } else {
                            let reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = function () {
                              // console.log(reader.result);
                              const dataSplit =
                                reader.result.split("base64,")[1];
                              // console.log(dataSplit)

                              setFieldValue("assetImage", file.name);

                              setFieldValue("imageData", dataSplit);
                            };
                            reader.onerror = function (error) {};
                            // }
                          } else {
                            setFieldValue("assetImage", "");
                            setFieldValue("imageData", "");
                          }
                        }}
                      />
                    </Button>
                    <Typography
                      sx={{
                        // mb: color.labelmb,

                        fontSize: color.labelFont,
                        // color: color.labelColor,
                      }}
                    >
                      {values.assetImage}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
              <Paper
                sx={{
                  width: { xs: "100%", sm: "49%" },
                  flex: "0 0 49%",
                  p: 1.5,
                }}
              >
                <Grid
                  container
                  spacing={"0.5rem"}
                  sx={
                    {
                      // boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                      // p:1.5,
                      // backgroundColor: "white",
                    }
                  }
                >
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Serial Number
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="text"
                      name="serialNumber"
                      placeholder="Enter Serial Number"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>
                  {/* <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Model
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="model"
                  placeholder="Enter Model"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid> */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Model
                    </Typography>
                    <Field
                      name="modelId"
                      value={
                        model.find((m) => m.id === values.modelId) || null
                      }
                      component={Autocomplete}
                      filterOptions={filterOptions}
                      loading={model.length === 0}
                      options={model}
                      PaperComponent={CustomPaper}
                      getOptionLabel={(option) =>
                        option ? option.code + " - " + option.modelName : ""
                      }
                      onChange={(event, value) => {
                        if (value) {
                          console.log(value);
                          setFieldValue("modelId", value.id);
                        } else {
                          setFieldValue("modelId", null);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="modelId"
                          placeholder="Search Model"
                          onChange={handleChange}
                          size="small"
                          // variant="standard"

                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                {model.length === 0 ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    ></Field>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Purchase Price
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="text"
                      name="purchasePrice"
                      placeholder="Enter Purchase Price"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
                  >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Installation Date
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoItem>
                        <DatePicker
                          format="DD/MM/YYYY"
                          // value={dayjs(values.installationDate)}
                          value={
                            values.installationDate
                              ? dayjs(values.installationDate)
                              : null
                          }
                          //   sx={{".css-1xhypcz-MuiStack-root":{
                          //     padding:0
                          //   }}}
                          slotProps={{
                            textField: { size: "small", margin: "-8px 0 0 0" },
                          }}
                          onChange={(newValue) => {
                            console.log(newValue);
                            if (newValue !== null) {
                              if (`${newValue.$d}` !== "Invalid Date") {
                                const dateFrom = getDateWithOutUTC(newValue);
                                setFieldValue("installationDate", dateFrom);
                              } else {
                                setFieldValue("installationDate", null); // clear when no date selected
                              }
                            }
                          }}
                        />
                      </DemoItem>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Suppiler
                    </Typography>
                    <Field
                      as={Select}
                      // label={"Select"}
                      size={"small"}
                      type="text"
                      name="supplierId"
                      fullWidth
                      displayEmpty
                      MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                      renderValue={
                        values.supplierId !== null
                          ? undefined
                          : () => (
                              <Typography
                                sx={{
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                }}
                              >
                                Select
                              </Typography>
                            )
                      }
                    >
                      {suppiler.map((id, i) => (
                        <MenuItem value={id.value}>{id.text}</MenuItem>
                      ))}
                    </Field>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Manufacturer
                    </Typography>
                    <Field
                      as={Select}
                      // label={"Select"}
                      size={"small"}
                      type="text"
                      name="manufacturerId"
                      fullWidth
                      displayEmpty
                      MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                      renderValue={
                        values.manufacturerId !== null
                          ? undefined
                          : () => (
                              <Typography
                                sx={{
                                  color: color.placeholderColor,
                                  fontSize: "13px",
                                }}
                              >
                                Select
                              </Typography>
                            )
                      }
                    >
                      {manufacturer.map((id, i) => (
                        <MenuItem value={id.value}>{id.text}</MenuItem>
                      ))}
                    </Field>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Comments
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="text"
                      name="comments"
                      placeholder="Enter Comments"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Notes
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="text"
                      name="notes"
                      placeholder="Enter Notes"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "1rem",
                flexWrap: "noWrap",
                width: "100%",
                flexDirection: { xs: "column", md: "row" },
                mt: "1rem",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "100%", sm: "49%" },
                  flex: "0 0 49%",
                  p: 1.5,
                }}
              >
                <Grid
                  container
                  spacing={"0.5rem"}
                  sx={
                    {
                      // boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                      // p:1.5,
                      // backgroundColor: "white",
                    }
                  }
                >
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Warranty Name
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="text"
                      name="warrantyName"
                      placeholder="Enter Asset Warranty Name"
                      fullWidth
                      sx={{
                        ".MuiInputBase-input": {
                          // letterSpacing: "0.2rem",

                          "&::placeholder": {
                            // color: "green",
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>
                  {/* <Grid
                item
                xs={12}
                md={6}
                sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
              >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Start Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DatePicker
                      format="DD/MM/YYYY"
                      //value={dayjs(values.startDate)}
                      value={values.startDate ? dayjs(values.startDate) : null}
                      //   sx={{".css-1xhypcz-MuiStack-root":{
                      //     padding:0
                      //   }}}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0" },
                      }}
                      onChange={(newValue) => {
                        console.log(newValue);
                        if (newValue !== null) {
                          if (`${newValue.$d}` !== "Invalid Date") {
                            const dateFrom = moment(newValue.$d).format(
                              "YYYY-MM-DD"
                            );
                            const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                            const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                            const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                            const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                            setFieldValue("startDate", dateFormat);
                          }
                          else {
                            setFieldValue("startDate", null); // clear when no date selected
                          }
                        }
                      }}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </Grid> */}

                  {/* <Grid
                item
                xs={12}
                md={4}
                sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
              >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  ThreshHold Calendar
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DatePicker
                      format="DD/MM/YYYY"
                     // value={dayjs(values.threshHoldCalendar)}
                     value={values.threshHoldCalendar ? dayjs(values.threshHoldCalendar) : null}
                      //   sx={{".css-1xhypcz-MuiStack-root":{
                      //     padding:0
                      //   }}}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0" },
                      }}
                      onChange={(newValue) => {
                        console.log(newValue);
                        if (newValue !== null) {
                          if (`${newValue.$d}` !== "Invalid Date") {
                            const dateFrom = moment(newValue.$d).format(
                              "YYYY-MM-DD"
                            );
                            const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                            const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                            const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                            const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                            setFieldValue("threshHoldCalendar",dateFormat);
                          } else {
                            setFieldValue("threshHoldCalendar", null); // clear when no date selected
                          }
                        }
                      }}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </Grid> */}
                  {/* <Grid item xs={12} md={6} >
              <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                ThreshHold Calendar(Month)
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="threshHoldCalendar"
                  placeholder="Enter Month"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid> 
                  <Grid
                item
                xs={12}
                md={6}
                sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
              >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Expiration Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DatePicker
                      format="DD/MM/YYYY"
                      value={values.expirationDate ? dayjs(values.expirationDate) : null}
                      //   sx={{".css-1xhypcz-MuiStack-root":{
                      //     padding:0
                      //   }}}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0" },
                      }}
                      onChange={(newValue) => {
                        console.log(newValue);
                        if (newValue !== null) {
                          if (`${newValue.$d}` !== "Invalid Date") {
                            const dateFrom = moment(newValue.$d).format(
                              "YYYY-MM-DD"
                            );
                            const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                            const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                            const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                            const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                            setFieldValue("expirationDate", dateFormat);
                          }else {
                            setFieldValue("expirationDate", null); // clear when no date selected
                          }
                        }
                      }}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </Grid> */}
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
                  >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Start Date
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoItem>
                        <DatePicker
                          format="DD/MM/YYYY"
                          value={
                            values.startDate ? dayjs(values.startDate) : null
                          }
                          slotProps={{
                            textField: { size: "small", margin: "-8px 0 0 0" },
                          }}
                          onChange={(newValue) => {
                            if (
                              newValue !== null &&
                              `${newValue.$d}` !== "Invalid Date"
                            ) {
                              const dateFrom = getDateWithOutUTC(newValue);
                              setFieldValue("startDate", dateFrom);

                              // 👇 Auto calculate Expiration Date if ThreshHoldCalendar is filled
                              if (values.threshHoldCalendar) {
                                const expDate = moment(newValue.$d)
                                  .add(
                                    Number(values.threshHoldCalendar),
                                    "months",
                                  )
                                  .format("YYYY-MM-DDTHH:mm:ss");
                                setFieldValue("expirationDate", expDate);
                              }
                            } else {
                              setFieldValue("startDate", null);
                              setFieldValue("expirationDate", null);
                            }
                          }}
                        />
                      </DemoItem>
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      ThreshHold Calendar (Month)
                    </Typography>
                    <Field
                      as={TextField}
                      size={"small"}
                      type="number"
                      name="expirationUsage"
                      placeholder="Enter Month"
                      fullWidth
                      onChange={(e) => {
                        const months = Number(e.target.value);
                        setFieldValue("expirationUsage", e.target.value);

                        // 👇 Auto calculate Expiration Date if Start Date is already chosen
                        if (values.startDate && !isNaN(months)) {
                          const expDate = moment(values.startDate)
                            .add(months, "months")
                            .format("YYYY-MM-DDTHH:mm:ss");
                          setFieldValue("expirationDate", expDate);
                        } else {
                          setFieldValue("expirationDate", null);
                        }
                      }}
                      sx={{
                        ".MuiInputBase-input": {
                          "&::placeholder": {
                            opacity: 1,
                            color: color.placeholderColor,
                            fontSize: "13px",
                          },
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
                  >
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Expiration Date
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoItem>
                        <DatePicker
                          format="DD/MM/YYYY"
                          value={
                            values.expirationDate
                              ? dayjs(values.expirationDate)
                              : null
                          }
                          readOnly
                          disableOpenPicker
                          slotProps={{
                            textField: { size: "small", margin: "-8px 0 0 0" },
                          }}
                          onChange={(newValue) => {
                            if (
                              newValue !== null &&
                              `${newValue.$d}` !== "Invalid Date"
                            ) {
                              const dateFrom = getDateWithOutUTC(newValue);
                              setFieldValue("expirationDate", dateFrom);
                            } else {
                              setFieldValue("expirationDate", null);
                            }
                          }}
                        />
                      </DemoItem>
                    </LocalizationProvider>
                  </Grid>

                  {/* <Grid item xs={12} md={4} >
              <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                 Expiration Usage
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="expirationUsage"
                  placeholder="Enter expiration Usage"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid> */}
                  <Grid item xs={12} md={4} lg={6}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        mb: color.labelmb,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Type
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        // flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: color.TabDatafontsize,
                          mb: color.TabDatamarginbottom,
                        }}
                      >
                        Basic
                      </Typography>
                      <Switch
                        value={values.warrantyType}
                        checked={values.warrantyType}
                        onChange={(e) => {
                          console.log(e.target.checked);
                          if (e.target.checked) {
                            setFieldValue("warrantyType", true);
                          } else {
                            setFieldValue("warrantyType", false);
                          }
                        }}
                        sx={{
                          width: 48,
                          height: 26,
                          padding: 0,

                          "& .MuiSwitch-switchBase": {
                            padding: 0,
                            margin: 0.2,
                            transitionDuration: "300ms",
                            "&.Mui-checked": {
                              transform: "translateX(22px)",
                              color: "#fff",
                              "& + .MuiSwitch-track": {
                                backgroundColor: (theme) =>
                                  theme.palette.mode === "dark"
                                    ? "#2ECA45"
                                    : "#217EDE",
                                opacity: 1,
                                border: 0,
                              },
                              "&.Mui-disabled + .MuiSwitch-track": {
                                opacity: 0.5,
                              },
                            },
                            "&.Mui-focusVisible .MuiSwitch-thumb": {
                              color: "#33cf4d",
                              border: "6px solid #fff",
                            },
                            "&.Mui-disabled .MuiSwitch-thumb": {
                              color: (theme) =>
                                theme.palette.mode === "light"
                                  ? theme.palette.grey[100]
                                  : theme.palette.grey[600],
                            },
                            "&.Mui-disabled + .MuiSwitch-track": {
                              opacity: (theme) =>
                                theme.palette.mode === "light" ? 0.7 : 0.3,
                            },
                          },
                          "& .MuiSwitch-thumb": {
                            boxSizing: "border-box",
                            width: 22,
                            height: 22,
                          },
                          "& .MuiSwitch-track": {
                            borderRadius: 26 / 2,
                            backgroundColor: (theme) =>
                              theme.palette.mode === "light"
                                ? "#E9E9EA"
                                : "#39393D",
                            opacity: 1,
                            transition: (theme) =>
                              theme.transitions.create(["background-color"], {
                                duration: 500,
                              }),
                          },
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: color.TabDatafontsize,
                          mb: color.TabDatamarginbottom,
                        }}
                      >
                        Extended
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Box>
            <Grid container item xs={12} justifyContent={"flex-end"} gap="1rem">
              <Button
                onClick={handleCancel}
                variant="contained"
                sx={{
                  backgroundColor: color.TableCancelButton,
                  textTransform: "none",
                  color: color.CancelTextColor,
                  ":hover": {
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                type={"submit"}
                variant="contained"
                disabled={loading}
                sx={{
                  textTransform: "none",
                  backgroundColor: loading ? "default" : color.TableButtonColor,
                  "&:hover": {
                    backgroundColor: loading ? "default" : color.buttonDisable,
                  },
                }}
              >
                Submit
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
      {/* </Paper> */}
    </Box>
  );
};

export default AssetModal;
